"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EsCoUsd = exports.EsCoCop = void 0;
class EsCoCop {
    constructor() {
        this.locale = "es-co";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "COP",
            symbol: "$",
            decimalSeparator: "",
            groupSeparator: ".",
            positivePattern: "Cn",
            negativePattern: "(Cn)",
        };
    }
}
exports.EsCoCop = EsCoCop;
class EsCoUsd {
    constructor() {
        this.locale = "es-co";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: "",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.EsCoUsd = EsCoUsd;
